// src/cart/CartItem.js
import React from 'react';
import { getPlaceholderImage } from '../utils/imageHelper';
import { formatPackingInfo } from '../utils/textHelper';

const CartItem = ({ item, updateQuantity, removeFromCart }) => {
    const [imgSrc, setImgSrc] = React.useState(item.imageUrl || getPlaceholderImage(item.name));
    const itemTotal = item.price * item.quantity;
    const companyName = item.company || item.Company || item.product_manufactured || item.brand;

    return (
        <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 p-4 bg-white rounded-2xl border border-slate-100 shadow-sm hover:shadow-md transition-shadow">
            <div className="flex items-center gap-4 w-full sm:w-auto sm:flex-1">
                {/* Product Image */}
                <div className="w-20 h-20 flex-shrink-0 bg-slate-50 rounded-xl overflow-hidden border border-slate-100 flex items-center justify-center p-1">
                    <img
                        src={imgSrc}
                        alt={item.name}
                        className="w-full h-full object-contain"
                        onError={() => setImgSrc(getPlaceholderImage(item.name))}
                    />
                </div>

                {/* Product Info */}
                <div className="flex-1 min-w-0">
                    {companyName && (
                        <p className="text-[10px] sm:text-xs text-sky-600 font-bold uppercase tracking-wider mb-0.5 line-clamp-1">{companyName}</p>
                    )}
                    <h3 className="font-bold text-slate-800 text-sm sm:text-base leading-tight line-clamp-2 mb-1">{item.name}</h3>
                    
                    {/* Packing and Units */}
                    {(item.pack || item.unit) && (
                        <div className="flex flex-wrap gap-2 mb-2 mt-1">
                            <span className="bg-sky-50 text-sky-600 font-semibold px-2.5 py-0.5 rounded-full text-[10px]">
                                {formatPackingInfo(item.pack, item.unit, '', item.name)}
                            </span>
                        </div>
                    )}

                    <p className="text-xs text-slate-500">MRP: <span className="font-semibold text-slate-700">₹{item.price.toFixed(2)}</span></p>
                    <p className="text-[10px] text-slate-400 italic mt-0.5">* Price may vary. Billed at actuals.</p>
                </div>
            </div>

            <div className="flex items-center justify-between w-full sm:w-auto sm:gap-4 mt-2 sm:mt-0 pt-2 sm:pt-0 border-t border-slate-50 sm:border-0">
                {/* Quantity Controls */}
                <div className="flex items-center gap-1 bg-slate-100 rounded-xl p-1">
                    <button
                        onClick={() => updateQuantity(item.productId, 'decrease')}
                        className="w-7 h-7 rounded-lg bg-white shadow-sm text-slate-700 font-bold hover:bg-red-50 hover:text-red-600 transition-colors flex items-center justify-center text-sm"
                    >−</button>
                    <span className="w-8 text-center font-bold text-slate-800 text-sm">{item.quantity}</span>
                    <button
                        onClick={() => updateQuantity(item.productId, 'increase')}
                        className="w-7 h-7 rounded-lg bg-white shadow-sm text-slate-700 font-bold hover:bg-sky-50 hover:text-sky-600 transition-colors flex items-center justify-center text-sm"
                    >+</button>
                </div>

                {/* Item Total */}
                <div className="text-right flex-shrink-0 min-w-[70px]">
                    <p className="font-extrabold text-slate-900 text-base">₹{itemTotal.toFixed(2)}</p>
                    <button
                        onClick={() => removeFromCart(item.productId)}
                        className="text-red-400 hover:text-red-600 transition-colors mt-1"
                        title="Remove Item"
                    >
                        <i className="fas fa-trash-alt text-base"></i>
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CartItem;
